import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const KEY = "streateat_favorites";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export const useFavorites = () => {
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener("favorites-changed", sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener("favorites-changed", sync); window.removeEventListener("storage", sync); };
  }, []);

  const toggle = useCallback((slug) => {
    const cur = read();
    const added = !cur.includes(slug);
    const next = added ? [...cur, slug] : cur.filter((s) => s !== slug);
    localStorage.setItem(KEY, JSON.stringify(next));
    setFavs(next);
    window.dispatchEvent(new Event("favorites-changed"));
    if (localStorage.getItem("streateat_token")) {
      (added ? api.post(`/me/favorites/${slug}`) : api.delete(`/me/favorites/${slug}`)).catch(() => {});
    }
    if (added) api.post(`/track/${slug}`, { type: "favorite" }).catch(() => {});
    return added;
  }, []);

  const isFav = useCallback((slug) => favs.includes(slug), [favs]);
  return { favs, toggle, isFav };
};
